import { api } from "@repo/convex/api";
import { useObservedMutation } from "@/hooks/use-observed-convex";

// ============================================================================
// Clarification Feature - Mutation Hooks
// ============================================================================
// Hooks for creating and updating clarification requests via Convex mutations

/**
 * Create a new clarification request.
 * Supports entity/field scoping for targeted clarifications.
 */
export function useCreateClarification() {
  return useObservedMutation(api.clarifications.create, {
    feature: "clarification",
    operation: "create",
    includeRequestId: true,
  });
}

/**
 * Create a clarification request with its optional first message atomically.
 */
export function useCreateClarificationWithInitialMessage() {
  return useObservedMutation(api.clarifications.createWithInitialMessage, {
    feature: "clarification",
    operation: "create-with-initial-message",
    includeRequestId: true,
  });
}

/**
 * Update an existing clarification request.
 * Can update status (open ↔ closed), title, owner, and related KPIs.
 */
export function useUpdateClarification() {
  return useObservedMutation(api.clarifications.update, {
    feature: "clarification",
    operation: "update",
    includeRequestId: true,
  });
}

/**
 * Post a new message to a clarification thread.
 */
export function usePostClarificationMessage() {
  return useObservedMutation(api.clarifications.postMessage, {
    feature: "clarification",
    operation: "post-message",
    includeRequestId: true,
  });
}

/**
 * Mark a clarification thread as read for the current user.
 */
export function useMarkClarificationRead() {
  return useObservedMutation(api.clarifications.markRead, {
    feature: "clarification",
    operation: "mark-read",
    includeRequestId: true,
  });
}
